import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { RiSearchLine } from 'react-icons/ri';
import { IconContext } from 'react-icons';

import WidgetShell from '../WidgetShell';

const SearchWidget = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [value, setValue] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault();
    const trimmed = value.trim();
    if (!trimmed) {
      navigate('/search');
      return;
    }
    navigate(`/search?q=${encodeURIComponent(trimmed)}`);
  };

  return (
    <WidgetShell className="">
      <form onSubmit={handleSubmit} className="px-3 pb-2 pt-2">
        <label htmlFor="right-sidebar-search" className="sr-only">
          {t('rightSidebar.widgets.search.label')}
        </label>
        <div className="relative text-on-surface/60 focus-within:text-primary">
          <div className="absolute top-1/2 -translate-y-1/2 left-3">
            <IconContext.Provider
              // eslint-disable-next-line react/jsx-no-constructed-context-values
              value={{ size: '18px', style: { color: 'inherit' } }}
            >
              <RiSearchLine />
            </IconContext.Provider>
          </div>
          <input
            id="right-sidebar-search"
            type="search"
            value={value}
            onChange={(event) => setValue(event.target.value)}
            placeholder={t('rightSidebar.widgets.search.placeholder')}
            className="w-full py-2 pl-10 pr-3 rounded-full bg-on-surface/10 text-on-surface placeholder-on-surface/50 outline-none border border-transparent focus:border-primary focus:bg-surface"
            autoComplete="off"
          />
        </div>
      </form>
    </WidgetShell>
  );
};

export default SearchWidget;
